export function stringComparator(
  a: string,
  b: string,
  option?: {
    caseSensitive?: boolean;
    reverse?: boolean;
    locales?: string | string[];
  },
) {
  const { caseSensitive = false, reverse = false, locales = ['en', 'th'] } = option ?? {};

  const comparison = a.localeCompare(b, locales, {
    sensitivity: caseSensitive ? 'case' : 'base',
  });

  return reverse ? -comparison : comparison;
}
